/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Grid, FormLabel, Button, FormHelperText, Typography } from '@material-ui/core'

const styles = theme => ({
    formControl: {
        margin: theme.spacing(0)
    },
    buttons: {
        position: 'relative'
    },
    button: {
        width: '100%',
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5)
    },
    radio: {
        minWidth: '110px',
        alignItems: 'start'
    },
    selectButtons: {
        marginTop: theme.selectButtons ? theme.selectButtons.marginTop : null,
        [theme.breakpoints.down(600)]: {
            marginTop: theme.selectButtons ? theme.selectButtons.marginTop / 2 : null
        }
    },
    selectButton: {
        fontFamily: theme.fontFamily,
        marginTop: theme.spacing(1),
        width: '100%',
        color: theme.selectButton ? theme.selectButton.color : null,
        borderRadius: theme.selectButton ? theme.selectButton.borderRadius : null,
        border: theme.selectButton ? theme.selectButton.border : null,
        boxShadow: theme.selectButton ? theme.selectButton.boxShadow : null,
        background: theme.selectButton ? theme.selectButton.background : null,
        '&:hover': {
            background: theme.selectButton ? theme.selectButton.hoverBackground : null,
            border: theme.selectButton ? theme.selectButton.hoverBorder : null,
            color: theme.selectButton ? theme.selectButton.hoverColor : null
        }
    },
    selectButtonRoot: {
        textTransform: theme.selectButton ? theme.selectButton.textTransform : null,
        color: theme.selectButton ? theme.selectButton.color : null,
        padding: theme.selectButton ? theme.selectButton.padding : null,
        fontSize: theme.selectxsFontSize,
        fontWeight: theme.selectxsFontWeight,
        letterSpacing: theme.selectButton ? theme.selectButton.letterSpacing : null,
        textShadow: theme.selectButton ? theme.selectButton.textShadow : null,
        //background: theme.selectButton ? theme.selectButton.background : null,
        [theme.breakpoints.up(600)]: {
            fontSize: theme.selectmdFontSize,
            fontWeight: theme.selectmdFontWeight
        }
    },
    selectedButtonRoot: {
        background: theme.palette.primaryColor + '!important',
        border: theme.selectedButton ? theme.selectedButton.border : null
        //textShadow: '0 0 1px rgba(0, 0, 0, 0.5)',
    },
    nonSelectedButtonRoot: {
        background: theme.selectButton ? theme.selectButton.nonSelectedBackground : null
    },
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    lgTitle: {
        fontSize: '1.5rem',
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.primary,
        lineHeight: 1.15
    },
    customTitleSize: {
        marginTop: 0
    },
    marginBottom: {
        [theme.breakpoints.up(600)]: {
            marginBottom: theme.spacing(3) + 'px!important'
        }
    },
    optionHelper: {
        fontFamily: theme.fontFamily,
        color: theme.body2Color,
        textAlign: theme.optionHelper ? theme.optionHelper.textAlign : ''
    },
    label: {
        marginBottom: theme.spacing(1.5) + 'px!important'
    },
    group: {
        marginTop: 15
    },
    buttonWithoutImage: {
        padding: 6
    },
    checkedIcon: {
        margin: '0 15px',
        position: 'absolute',
        left: theme.checkedIcon && theme.checkedIcon.left ? theme.checkedIcon.left : '7px',
        color: '#ffffff!important'
    },
    optionIcon: {
        margin: '-1.5px 15px',
        position: 'absolute',
        right: '7px',
        [theme.breakpoints.down(450)]: {
            display: 'none'
        }
    },
    optionGroupTitle: {
        fontSize: '15px!important',
        textAlign: theme.optionGroupTitle ? theme.optionGroupTitle.textAlign : 'center',
        //borderBottom: '2px solid rgba(0, 0, 0, 0.11)',
        marginBottom: -6,
        marginTop: 26,
        //fontWeight: 500,
        [theme.breakpoints.down(450)]: {
            marginTop: 20
        }
    },
    optionGroupTitleFirst: {
        marginTop: '0px!important'
    },
    legend: {
        padding: '0px 0 0 0!important',
        marginBottom: -12,
        [theme.breakpoints.down(600)]: {
            marginBottom: -8,
            padding: '6px 0 0 0!important'
        }
    },
    helperText: {
        marginTop: theme.spacing(1.5),
        fontSize: '0.875rem',
        color: theme.palette.text.primary,
        lineHeight: 1.43
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '0px 4px 4px 4px!important'
        },
        selectButton: {
            marginTop: '4px!important'
        },
        selectButtonRoot: {
            paddingTop: theme.spacing(0.6) + 'px!important',
            paddingBottom: theme.spacing(0.6) + 'px!important'
        }
    },
    selectedButtonLabelWrapper: {
        padding: '0 22px',
        zIndex: 1
    }
})

class SelectButtonsQuestion extends Component {
    handleChange = value => {
        this.props.onValueChanged(this.props.question.id, value)
    }

    render() {
        const { classes, question, value, className } = this.props

        return (
            <>
                <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)} className={classes.questionWrapper + ' ' + className}>
                    {!question.titleSize && (
                        <FormLabel component="legend" className={classes.legend}>
                            {question.title}
                        </FormLabel>
                    )}
                    {question.titleSize && (
                        <Typography
                            variant={question.titleSize}
                            gutterBottom
                            className={classes.customTitleSize + ' ' + (question.titleSize === 'h4' ? classes.marginBottom : null)}
                        >
                            {question.title}
                        </Typography>
                    )}
                    {question.description && (
                        <Typography component="span" style={{ marginBottom: 4 }} className={classes.description}>
                            {parse(question.description)}
                        </Typography>
                    )}
                    <Grid container spacing={1} className={question.title ? classes.selectButtons : null}>
                        {question.options &&
                            question.options.map((option, key) => {
                                return [
                                    option.group_title && (
                                        <Grid item xs={12} sm={12} key={question.id + '|g|' + key}>
                                            <Typography
                                                component="span"
                                                className={classes.optionGroupTitle + ' ' + (key === 0 ? classes.optionGroupTitleFirst : null)}
                                            >
                                                {option.group_title}
                                            </Typography>
                                        </Grid>
                                    ),
                                    <Grid
                                        item
                                        xs={parseInt(option.xsCols)}
                                        sm={parseInt(option.smCols)}
                                        key={question.id + '|' + key}
                                        style={{ paddingBottom: 0 }}
                                    >
                                        {false && (
                                            <Button
                                                variant={value === option.value ? 'contained' : 'outlined'}
                                                color="primary"
                                                classes={{ root: classes.selectButtonRoot }}
                                                className={classes.selectButton}
                                                style={value === option.value ? { color: 'white' } : null}
                                                onClick={() => this.handleChange(option.value)}
                                                key={key}
                                            >
                                                {option.label}
                                                {option.icon && <FontAwesomeIcon className={classes.optionIcon} icon={['far', option.icon]} />}
                                            </Button>
                                        )}
                                        {!!true && (
                                            <Button
                                                variant={'contained'}
                                                color={value === option.value ? 'primary' : 'default'}
                                                classes={{
                                                    root:
                                                        classes.selectButtonRoot +
                                                        ' ' +
                                                        (value === option.value ? classes.selectedButtonRoot : classes.nonSelectedButtonRoot)
                                                }}
                                                className={classes.selectButton}
                                                style={value === option.value ? { color: '#ffffff' } : null}
                                                onClick={() => this.handleChange(option.value)}
                                                key={key}
                                            >
                                                {value === option.value && (
                                                    <FontAwesomeIcon className={classes.checkedIcon} icon={['far', 'check']} />
                                                )}
                                                <span className={value === option.value ? classes.selectedButtonLabelWrapper : null}>
                                                    {option.label}
                                                </span>
                                                {option.icon && <FontAwesomeIcon className={classes.optionIcon} icon={['far', option.icon]} />}
                                            </Button>
                                        )}
                                        {option.description && <FormHelperText className={classes.optionHelper}>{option.description}</FormHelperText>}
                                    </Grid>
                                ]
                            })}
                        {question.valid === false && (
                            <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                                <FormHelperText className={classes.errorText}>{question.errorMessage}</FormHelperText>
                            </Grid>
                        )}
                        {question.helperText && (
                            <Grid item xs={12}>
                                <FormHelperText className={classes.helperText}>{parse(question.helperText)}</FormHelperText>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </>
        )
    }
}

export default withStyles(styles)(SelectButtonsQuestion)
